import React, { useEffect, useRef } from 'react';
import './note-dropdown-menu.css';
import { updateNote } from '../../../cardModalFall2023UtilFunctions';

const NoteDropdownMenu = ({ setOpenMenu, editNote, deleteAndRemoveNote, note, updateAndReplaceNote }) => {
  const menuRef = useRef();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpenMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [setOpenMenu]);

  const handleEditNote = () => {
    editNote();
    setOpenMenu(false);
  }

  const markAsImportant = async () => {
    let updatedNote = await updateNote({
      ...note,
      important: true
    })
    console.log(updatedNote)
    updateAndReplaceNote(updatedNote)
    setOpenMenu(false);
  }

  return (
    <div className='note-dropdown-menu__wrapper' ref={menuRef}>
      <div className='note-dropdown-menu__option' onClick={() => handleEditNote()}>Edit</div>
      <div className='note-dropdown-menu__option' onClick={() => markAsImportant()}>Mark as important</div>
      <div className='note-dropdown-menu__option' onClick={() => deleteAndRemoveNote()}>Delete</div>
    </div>
  );
};

export default NoteDropdownMenu;
